import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate(redirect);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="container-editorial mt-14">
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6 md:col-start-4">
          <p className="label-uppercase text-[#B24C38]">Welcome back</p>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mt-3">Sign In</h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <label className="label-uppercase block mb-2">Email</label>
              <Input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                     className="rounded-none border-[#111] bg-transparent h-12"/>
            </div>
            <div>
              <label className="label-uppercase block mb-2">Password</label>
              <Input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)}
                     className="rounded-none border-[#111] bg-transparent h-12"/>
            </div>
            <button type="submit" disabled={loading} className="btn-terracotta w-full justify-center" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign In →"}
            </button>
            <p className="text-sm text-[#4A4A4A]">
              New to Kesher? <Link to={`/register?redirect=${encodeURIComponent(redirect)}`} className="link-underline text-[#111]" data-testid="login-to-register">Create an account</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
